import { useState } from 'react';
import { toast } from 'react-toastify';

/**
 * Custom hook for managing form validation dialog
 * Provides methods to show validation errors or success messages
 *
 * @param {object} config - Optional configuration for form-specific settings
 * @param {object} fieldLabels - Optional field label mappings for this form
 * @returns {object} Object containing validation dialog state and methods
 */
const useValidationDialog = (config = {}, fieldLabels = null) => {
    const [validationErrors, setValidationErrors] = useState([]);
    const [showValidationDialog, setShowValidationDialog] = useState(false);

    /**
     * Show validation errors in modal dialog
     * @param {array} errors - Array of error messages
     */
    const showValidationErrors = (errors) => {
        setValidationErrors(errors);
        setShowValidationDialog(true);

        // Scroll to first error field
        setTimeout(() => {
            const firstErrorField = document.querySelector(
                '[style*="border: 2px solid rgb(226, 0, 0)"], [style*="outline: 2px solid rgb(226, 0, 0)"]'
            );
            if (firstErrorField) {
                firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 100);
    };

    /**
     * Show success message
     * @param {string} message - Success message (optional)
     */
    const showSuccess = (message = 'Form submitted successfully!') => {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
        });
    };

    /**
     * Close validation dialog
     */
    const closeDialog = () => {
        setShowValidationDialog(false);
        setValidationErrors([]);
    };

    return {
        // State
        validationErrors,
        showValidationDialog,

        // Methods
        showValidationErrors,
        showSuccess,
        closeDialog,

        // Configuration (pass through to ValidationDialog)
        config,
        fieldLabels
    };
};

export default useValidationDialog;